import _ from 'lodash';
import moment from 'moment-timezone';
import './common/theme';

window._ = _;
window.moment = moment;
